var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.26687L6 10.6922L0 4.26687L2.76169 1.30786H9.23831L12 4.26687Z",
    fill: "#59B6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.26687L6 10.6922V1.30786H9.23831L12 4.26687Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.26687H0L2.76169 1.30786H9.23831L12 4.26687Z",
    fill: "#EAF8FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 1.30786L3.75621 4.26687H0L2.76169 1.30786H6Z",
    fill: "#9AD2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.26687H8.24379L6 1.30786H9.23831L12 4.26687Z",
    fill: "#7FC8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24443 4.26685L6.00063 10.6922L3.75684 4.26685H8.24443Z",
    fill: "#9AD2FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24379 4.26685L6 10.6922V4.26685H8.24379Z",
    fill: "#59B6FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.26687H6V1.30786H9.23831L12 4.26687Z",
    fill: "#9AD2FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.26687H8.24379L6 1.30786H9.23831L12 4.26687Z",
    fill: "#59B6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarDiamond);
export default __webpack_public_path__ + "static/media/avatar_diamond.08c2a9768ddf247853c3ea3c9491591d.svg";
export { ForwardRef as ReactComponent };